export default __webpack_public_path__ + "static/media/lock.e5563ddb.svg";